import { PurchasesActionsType } from 'api-hooks/general/model';
import { PurchaseModel } from 'api-hooks/order/common';
import { useCancelPurchaseReceiveAgentCommission } from 'api-hooks/order/common/mutation';
import { PurchaseTransactionTypeEnum } from 'common/constants/enum';
import notification from 'components/common/notification';
import useDialog from 'hooks/use-dialog';
import useDismiss from 'hooks/use-dismiss';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export default function useCancelReceiveCommissionAction(data: PurchaseModel) {
  const { t } = useTranslation();
  const id = data.id;
  const cancelMutate = useCancelPurchaseReceiveAgentCommission(id);
  const dialog = useDialog();
  const type = React.useMemo<PurchasesActionsType>(() => {
    switch (data.transactionType) {
      case PurchaseTransactionTypeEnum.Flight:
        return 'flight-purchases';
      case PurchaseTransactionTypeEnum.Hotel:
        return 'hotel-purchases';
      case PurchaseTransactionTypeEnum.Cruise:
        return 'cruise-purchases';
      case PurchaseTransactionTypeEnum.Document:
        return 'document-purchases';
      case PurchaseTransactionTypeEnum.Activity:
        return 'activity-purchases';
      case PurchaseTransactionTypeEnum.Product:
        return 'product-purchases';
      default:
        return 'product-purchases';
    }
  }, [data.transactionType]);

  const onDismiss = useDismiss(type, id);

  const onCancel = React.useCallback(
    async (onClose?: () => void) => {
      dialog.showConfirmation({
        title: t('common:warning'),
        message: t('common:cancel_agent_commission_description'),
        async onPositiveAction(dismiss) {
          try {
            const result = await cancelMutate.mutateAsync({});
            notification.success({
              message: result.message,
            });
            dismiss();
            onClose?.();
            onDismiss();
          } catch (e) {
            notification.warning({
              message: e.message,
            });
          }
        },
        async onNegativeAction(dismiss) {
          dismiss();
        },
      });
    },
    [cancelMutate, dialog, onDismiss, t],
  );

  return {
    ...cancelMutate,
    onCancel,
  };
}
